export { default } from './InfoCircle'
